/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkLookupReleaseResponseRecordingsInner
 */
export interface BulkLookupReleaseResponseRecordingsInner {
    /**
     * 
     * @type {string}
     * @memberof BulkLookupReleaseResponseRecordingsInner
     */
    recordingId: string;
    /**
     * This recording's existing edge to the release, or null when it isn't linked to it.
     * @type {string}
     * @memberof BulkLookupReleaseResponseRecordingsInner
     */
    edgeId?: string | null;
}

/**
 * Check if a given object implements the BulkLookupReleaseResponseRecordingsInner interface.
 */
export function instanceOfBulkLookupReleaseResponseRecordingsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "recordingId" in value;

    return isInstance;
}

export function BulkLookupReleaseResponseRecordingsInnerFromJSON(json: any): BulkLookupReleaseResponseRecordingsInner {
    return BulkLookupReleaseResponseRecordingsInnerFromJSONTyped(json, false);
}

export function BulkLookupReleaseResponseRecordingsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkLookupReleaseResponseRecordingsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recordingId': json['recording_id'],
        'edgeId': !exists(json, 'edge_id') ? undefined : json['edge_id'],
    };
}

export function BulkLookupReleaseResponseRecordingsInnerToJSON(value?: BulkLookupReleaseResponseRecordingsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recording_id': value.recordingId,
        'edge_id': value.edgeId,
    };
}

